import { configureStore } from '@reduxjs/toolkit';
import authSlice from './slices/authSlice';
import authAlertSlice from './slices/authAlertSlice';
import dashboardSlice from './slices/dashboardSlice';
import parkingsSlice from './slices/parkingsSlice';
import ticketsSlice from './slices/ticketsSlice';
import usersSlice from './slices/usersSlice';

export const store = configureStore({
  reducer: {
    auth: authSlice,
    authAlert: authAlertSlice,
    dashboard: dashboardSlice,
    parkings: parkingsSlice,
    tickets: ticketsSlice,
    users: usersSlice,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST'],
      },
    }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
